import { ProfileStatus } from "@/constants/profile";
import type { ProfileStatus as ProfileStatusType } from "@/types/profile";
import { Badge, BADGE_STATUS } from "@/ui";
import { USER_STATUS_OPTIONS } from "@/utils/consts";

type ProfileStatusBadgeProps = {
  status: ProfileStatusType;
};

export const ProfileStatusBadge = ({ status }: ProfileStatusBadgeProps) => {
  let badgeStatus;

  if (status === ProfileStatus.active) {
    badgeStatus = BADGE_STATUS.SUCCESS;
  } else if (status === ProfileStatus.inactive) {
    badgeStatus = BADGE_STATUS.ERROR;
  } else if (status === ProfileStatus.pending_activation) {
    badgeStatus = BADGE_STATUS.WARNING;
  } else {
    badgeStatus = BADGE_STATUS.DEFAULT;
  }

  const label =
    USER_STATUS_OPTIONS.find((option) => {
      return option.value === status;
    })?.label ?? status;

  return <Badge status={badgeStatus}>{label}</Badge>;
};
